import React from "react";
import { Button } from "@kitbird/core";
import { ColumnI } from "../../../../../components/Table/TableProps";
import Table from "../../../../../components/Table";
import { ReactComponent as EditIcon } from "../../../../../assets/icons/edit.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/icons/trash.svg";
import useJobTitle from "../../hooks/useJobTitle";

interface JobTitleTableProps {
  setEditValue: React.Dispatch<React.SetStateAction<unknown>>
  showModal: () => void
  useCustomHook: ReturnType<typeof useJobTitle>
}

const JobTitleTable = ({
  setEditValue,
  showModal,
  useCustomHook: { search, dataJobTitles },
}: JobTitleTableProps) => {
  const columns: ColumnI[] = [
    {
      title: "Tipe User",
      dataIndex: "code_type",
      key: "code_type",
      render: (item) => {
        const codeType = {
          O: "HO",
          P: "Pool",
          H: "Pangkalan",
        };
        return codeType[item as "O" | "P" | "H"] || "";
      },
    },
    {
      title: "Jabatan",
      dataIndex: "job_title",
      key: "job_title",
    },
    {
      title: "Deskripsi",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      render: (item, row) => (
        <div style={{ display: "flex", gap: 8 }}>
          <Button style={{ padding: "8px 10px" }}
            onClick={() => {
              setEditValue(row);
              showModal();
            }}
          >
            <EditIcon width={16} height={16} />
          </Button>
          <Button style={{ padding: "8px 10px" }} backgroundColor={"rgb(203, 91, 75)"}>
            <TrashIcon width={16} height={16} />
          </Button>
        </div>
      ),
    },
  ];
  return (
    <Table
      withNumber
      columns={columns}
      dataSource={dataJobTitles?.lstsmplmstjobtitle
        .filter((item) => (
          item.job_title.toLowerCase().includes(search.toLowerCase())
          || item.description.toLowerCase().includes(search.toLowerCase())
        ))
      }
    />
  );
};

export default JobTitleTable;
